{
  "en": {
    "pvAnalysis": {
      "submissionSuccess": "PV analysis request successfully submitted",
      "submissionError": "Failed to submit PV analysis request",
      "noDocumentsSelected": "Please select at least one document"
    }
  },
  "fr": {
    "pvAnalysis": {
      "submissionSuccess": "Requête d'analyse PV envoyée avec succès",
      "submissionError": "Échec de l'envoi de la requête d'analyse PV",
      "noDocumentsSelected": "Veuillez sélectionner au moins un document"
    }
  },
  "nl": {
    "pvAnalysis": {
      "submissionSuccess": "PV-analyseverzoek succesvol ingediend",
      "submissionError": "Fout bij het indienen van PV-analyseverzoek",
      "noDocumentsSelected": "Selecteer alstublieft minstens één document"
    }
  }
}
